import { Resource } from './resource';
import gql from 'graphql-tag';

export class WorkdayResource extends Resource {
  public static async workdaysAndDayoffs(day: number, month: number, year: number) {
    return await this.query({
      query: gql`
        query($day: Int!, $month: Int!, $year: Int!) {
          workdays(day: $day, month: $month, year: $year) {
            userId
            date
            start
            end
          }
          dayoffs(day: $day, month: $month, year: $year) {
            userId
          }
        }
      `,
      variables: {
        day,
        month,
        year
      }
    });
  }

  public static async update(workdayId: number, start: number, end: number, overtimeAccepted?: boolean, overtimeLimit?: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($workdayId: Int!, $start: Int!, $end: Int, $overtimeAccepted: Boolean, $overtimeLimit: Int) {
            setWorkday(workdayId: $workdayId, start: $start, end: $end, overtimeAccepted: $overtimeAccepted, overtimeLimit: $overtimeLimit) {
              start
              end
              id
            }
          }
        `,
        variables: { workdayId, start, end, overtimeAccepted, overtimeLimit }
      },
      'setWorkday'
    );
  }

  public static async addWorkday(date: Date, cardNumber: string, start: number, end?: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($date: DateTime!, $cardNumber: String!, $start: Int!, $end: Int) {
            addWorkday(date: $date, cardNumber: $cardNumber, start: $start, end: $end) {
              id
              start
              end
              date
              overtimeLimit
              overtimeAccepted
              company {
                name
              }
              user {
                id
                firstName
                lastName
              }
            }
          }
        `,
        variables: { date, cardNumber, start, end }
      },
      'addWorkday'
    );
  }

  public static setOvertime(dateStart: Date, dateEnd: Date, userId: number, overtimeAccepted: boolean, overtimeLimit: number) {
    const overtimeInput = { dateStart, dateEnd, userId, overtimeAccepted, overtimeLimit };
    return this.mutation(
      {
        mutation: gql`
          mutation($overtimeInput: OvertimeInput!) {
            setOvertime(overtimeInput: $overtimeInput) {
              id
            }
          }
        `,
        variables: { overtimeInput }
      },
      'setOvertime'
    );
  }
}
